import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Button, Refresh2Icon } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'

import type { ExploreFiltersAtom } from '../../../atoms'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  formId: string

  model: ExploreFiltersAtom
} & ClassNameProps

export const ExploreFilterFooter: React.FC<Props> = ({ formId, model }) => {
  const { t } = useTranslation()

  const resetFilters = useAction(model.resetFilters)
  const [filtersEditState] = useAtom(model.form.filtersEditState)

  const handleReset = () => resetFilters()

  return (
    <Root>
      <ButtonFilter
        variant="ghost"
        size="xs"
        radius="rounded"
        type="button"
        iconLeft={<Refresh2Icon />}
        onClick={handleReset}
      >
        {t('common.filter_reset')}
      </ButtonFilter>
      <ButtonFilter
        variant="solid"
        color="primary"
        size="xs"
        radius="rounded"
        form={formId}
        type="submit"
        disabled={
          !filtersEditState.isChanged || filtersEditState.isRangeExceeded
        }
      >
        {t('common.apply')}
      </ButtonFilter>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;

  padding: 18px 10px;
`

const ButtonFilter = styled(Button)`
  height: 34px;
  min-width: 100px;
  border-radius: 6px;
`
